import {AxiosError} from 'axios';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {ApiPathParam} from '../../models/SearchParamSchema';
import {POST_NOTIFICATION_SEARCH_RECIPIENT_LISTING_URL} from '../../constants/apiUrls';
import {Pageable, PageDataSort} from '../group-special-consideration/usePostGroupSCListing';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface NotificationSearchRecipientRequest {
  q: string;
  notificationType: string;
  isEmailNotification: boolean;
  excludedUserUuidList: string[];
  apiPathParam: ApiPathParam;
}

export interface NotificationSearchRecipientResponseContentObject {
  uuid: string;
  nricFinPassport: string;
  name: string;
  indexNo: string;
  examCentre: string;
  emailMobile: string;
}

export interface NotificationSearchRecipientResponse {
  content: NotificationSearchRecipientResponseContentObject[];
  pageable: Pageable;
  last: boolean;
  totalElements: number;
  totalPages: number;
  first: boolean;
  numberOfElements: number;
  size: number;
  number: number;
  sort: PageDataSort[];
  empty: boolean;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: NotificationSearchRecipientResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostNotificationSearchRecipient = ({onSuccess, onError}: Input = {}) => {
  const postNotificationSearchRecipient = async (
      requestData: NotificationSearchRecipientRequest
  ) => {
    const res = await axiosClient.post<NotificationSearchRecipientResponse>(
        POST_NOTIFICATION_SEARCH_RECIPIENT_LISTING_URL(requestData.apiPathParam),
        {
          q: requestData.q,
          notificationType: requestData.notificationType,
          isEmailNotification: requestData.isEmailNotification,
          excludedUserUuidList: requestData.excludedUserUuidList,
        }
    );
    return res.data;
  };

  return useCustomMutation(postNotificationSearchRecipient, {
    onSuccess,
    onError,
  });
};
